var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ffffff",
    width: 512,
    height: 512,
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M705.3 62.5H294.9c-18.9 0-34.2 15.3-34.2 34.2v806.6c0 18.9 15.3 34.2 34.2 34.2h410.4c18.9 0 34.2-15.3 34.2-34.2V96.7c0-18.9-15.3-34.2-34.2-34.2zM466.5 863.8c0-18.6 15.1-33.6 33.5-33.6 18.5 0 33.6 15 33.6 33.6 0 18.5-15.1 33.6-33.6 33.6s-33.5-15-33.5-33.6zm-179.8-57.5V168.9h426.8v637.4H286.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartIcon);
export default __webpack_public_path__ + "static/media/smartIcon.3ae711aee94d65f1958e0300901326be.svg";
export { ForwardRef as ReactComponent };